import { parseToHtml } from '@gem/modules/markdown';
import { encodeHtml } from '@gem/utils';

import Tasks from 'APP/Tasks';
import { MediaMessagePopup } from 'APP/main/PopupManager/Popups/MediaMessagePopup/MediaMessagePopup';
import { PayloadType } from 'APP/model/message/messageModel.types';
import { RouterLink } from 'APP/router/constants';
import { navigateTo } from 'APP/router/refs/navigateTo';
import Entities from 'STORE';

interface IStartEditMessage {
  groupId: string;
  editMessageId: string;
}

const MEDIA_PAYLOADS: (PayloadType | null)[] = [
  PayloadType.Video,
  PayloadType.Image,
  PayloadType.Album,
  PayloadType.File,
  PayloadType.AudioMessage,
];

export const startEditMessage = async ({
  groupId,
  editMessageId,
}: IStartEditMessage): Promise<void> => {
  const inputPanel = Entities.InputPanelsStore.getById(groupId);
  const group = Entities.GroupsStore.getGroupById(groupId);

  if (!group || !inputPanel) {
    return;
  }

  const isVoiceRecordingResult = await Tasks.messaging.checkVoiceRecording(groupId);

  if (!isVoiceRecordingResult) {
    return;
  }

  const message = group.messagesStore.getMessageById(editMessageId);

  if (!message) {
    return;
  }

  if (message.payload.payloadType === PayloadType.Article) {
    navigateTo({
      to: RouterLink.articleEdit,
      params: { id: message.groupId, messageId: message.id },
    });

    return;
  }

  if (MEDIA_PAYLOADS.includes(message.payload.payloadType)) {
    Tasks.app.openPopup(MediaMessagePopup, {
      params: {
        files: [],
        caption: message.renderPayload.comment,
        groupId: message.groupId,
        messageId: message.id,
      },
    });

    return;
  }

  if (inputPanel.replyMessage) {
    inputPanel.setReplyMessage(null);
  }

  if (inputPanel.quote) {
    inputPanel.setQuote(null);
  }

  inputPanel.setEditMessageId(editMessageId);

  const text = message.renderPayload.text || message.renderPayload.comment || '';
  const html = parseToHtml(encodeHtml(text));

  if (inputPanel.value !== html) {
    inputPanel.setValue(html);
  }
};
